// Auto-generated normalizer for table: CAR_BOOKING.Chofer
export function choferNormalize(row) {
  return {
    idChofer: row.idChofer ?? row.IdChofer ?? row['idChofer'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['idEmpleado'] ?? 0,
    numeroLicencia: row.numeroLicencia ?? row.NumeroLicencia ?? row['numeroLicencia'] ?? '',
    claseLicencia: row.claseLicencia ?? row.ClaseLicencia ?? row['claseLicencia'] ?? '',
    venceLicencia: row.venceLicencia ?? row.VenceLicencia ?? row['venceLicencia'] ?? '',
    observaciones: row.observaciones ?? row.Observaciones ?? row['observaciones'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    recibeNotificaciones: row.recibeNotificaciones ?? row.RecibeNotificaciones ?? true,
    // Enriched fields
    nombre: row.nombreCompleto ?? row.NombreCompleto ?? '',
    nombreCompleto: row.nombreCompleto ?? row.NombreCompleto ?? '',
    correo: row.correo ?? row.Correo ?? '',
    numeroEmpleado: row.numeroEmpleado ?? row.NumeroEmpleado ?? '',
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? '',
  };
}